import { serverAddr, serverAddrForCSV, serverAddrForXLSX } from "../networkConfig";
import { async } from "q";

export default {
	getProducts(args) {
		// let fields = [];
		let get_all = false;
		let recipe_steps__isnull = false
		if (args.fields.length)
			return serverAddr.get(
				`/product/?fields=${args.fields}&get_all=${args.get_all}&recipe_steps__isnull=${args.recipe_steps__isnull}&check_intermediate=true`
			);
		else
			return serverAddr.get(
				`/product/?get_all=${get_all}&recipe_steps__isnull=${recipe_steps__isnull}`
			);
	},
	getProduct(productId, ...args) {
		if (args && args.length)
			// return serverAddr.get(`/product/91168815-811c-4881-a323-55660babe6d1/?check_intermediate=true&fields=${args}`);
			return serverAddr.get(`/product/${productId}/?check_intermediate=true&fields=${args}`);
		else return serverAddr.get(`/product/${productId}/`);
	},
	getArticles({ fields = [], type = "",  type1 = "", get_all = false } = {}) {
		if (fields.length)
			return serverAddr.get(
				`/article/?fields=${fields}&get_all=${get_all}&type=${type}`
			);
		else if (type && !type1)
			return serverAddr.get(`/article/?get_all=${get_all}&type=${type}`);
		else if (type && type1)
			return serverAddr.get(`/article/?get_all=${get_all}&type=${type}&type=${type1}`);
		else return serverAddr.get(`/article/?get_all=${get_all}`);
	},
	getArticle({ ingredientId, fields = [] }) {
		if (fields.length)
			return serverAddr.get(`/article/${ingredientId}/?fields=${fields}`);
		else return serverAddr.get(`/article/${ingredientId}/`);
	},
	updateProduct(productId, params) {
		return serverAddr.patch(`/product/${productId}/?check_intermediate=true`, params);
	},
	createRecipe(productId, params) {
		return serverAddr.post(`/product/${productId}/recipe/`, params);
	},
	editRecipe({ product_id, recipe_id, waste = 0, quantity = 0 }) {
		return serverAddr.patch(`/product/${product_id}/recipe/${recipe_id}/`, {
			waste,
			quantity
		});
	},
	deleteIngredient({ product_id, recipe_id } = {}) {
		return serverAddr.delete(`/product/${product_id}/recipe/${recipe_id}/`);
	},

	//suppliers apis
	getVendors({ fields = ["id", "account_info"], get_all = false } = {}) {
		return serverAddr.get(`/vendor/?fields=${fields}&get_all=${get_all}`);
	},
	getVendor({ vendorId, fields = ["id"] }) {
		return serverAddr
			.get(`/vendor/${vendorId}/`)
			.catch(err => console.log(err));
	},
	createVendor(params) {
		return serverAddr.post("/vendor/", params).catch(err => console.log(err));
	},
	editVendor({ vendorId, params } = {}) {
		return serverAddr.patch(`/vendor/${vendorId}/`, params);
	},
	deleteVendor({ vendorId } = {}) {
		return serverAddr.delete(`/vendor/${vendorId}/`);
	},
	createVendorSupplies({ vendorId, params } = {}) {
		return serverAddr.post(`/vendor/${vendorId}/articles/`, params);
		// .catch(err => {
		// 	throw err;
		// });
	},
	editVendorSupplies({ vendorId, articleId, params, pageInfo } = {}) {
		return serverAddr
			.patch(`/vendor/${vendorId}/articles/${articleId}/`, params)
			.catch(err => console.log(err));
	},
	deleteVendorSupplies({ vendorId, articleId } = {}) {
		return serverAddr
			.delete(`/vendor/${vendorId}/articles/${articleId}/`)
			.catch(err => console.log(err));
	},
	getVendorSupplies({ vendorId, pageInfo } = {}) {
		return serverAddr
			.get(
				`/vendor/${vendorId}/articles/?page=${pageInfo.currentPage}&page_size=${
					pageInfo.pageSize
				}`
			)
			.catch(err => console.log(err));
	},

	// neworder apis
	createOrder({ params } = {}) {
		return serverAddr.post("/orders/", params);
	},
	getOrdersPlan({ outletId, get_all = true } = {}) {
		return serverAddr.get(
			`/outlet/${outletId}/orders/plan/?get_all=${get_all}`
		);
	},
	getOutletInventoryItems({ outletId, get_all = true } = {}) {
		return serverAddr
			.get(`/outlet/${outletId}/inventory/articles/?get_all=${get_all}`)
			.catch(err => console.log(err));
	},
	getVendorList({
		articles = [],
		outlet = [],
		vendor_type,
		vendor_order_created_by,
		get_all = true
	} = {}) {
		return serverAddr
			.post(`/vendor/supply-articles/?get_all=${get_all}`, {
				articles,
				outlet
			})
			.catch(err => console.log(err));
	},
	getOrderOutlets({ get_all = true } = {}) {
		return serverAddr.get(`/orders/order-outlets/?get_all=${get_all}`);
		// .catch(err => {
		// 	// console.log("err", err.response.status);
		// 	// console.log(err);
		// 	return err;
		// });
	},

	// sent order apis
	getSentOrders({
		outlet,
		vendor,
		status,
		search = "",
		direction,
		date_start,
		date_end,
		pageInfo = {
			currentPage: 1,
			pageSize: 10
		}
	} = {}) {
		return serverAddr.post(
			`/orders/query/?page=${pageInfo.currentPage}&page_size=${
				pageInfo.pageSize
			}`,
			{
				outlet,
				vendor,
				status,
				...(search !== "" && { search: search }),
				direction,
				date_start,
				date_end
			}
		);
	},
	splitItem({ orderId, item } = {}) {
		return serverAddr.post(`/orders/${orderId}/items/${item.id}/split/`, {
			quantity: item.quantity,
			unit: item.unit,
			expiry_date: item.expiry_date,
			batch_number: item.batch_number
		});
	},
	orderStatusUpdate({ orderId, status } = {}) {
		return serverAddr.post(
			`/orders/${orderId}/update-status/?new_status=${status}`
		);
	},
	updateOrder({ orderId, params } = {}) {
		return serverAddr.patch(`/orders/${orderId}/`, params);
	},
	updateItemsInOrder({ orderId, params } = {}) {
		return serverAddr.patch(`/orders/${orderId}/items/update/`, params);
	},

	// stock calendar apis
	viewStockCountSchedule({
		outlet_id,
		pageInfo = { currentPage: 1, pageSize: 10 }
	} = {}) {
		return serverAddr
			.get(
				`/outlet/${outlet_id}/stock-count/calendar/?page=${
					pageInfo.currentPage
				}&page_size=${pageInfo.pageSize}`
			)
			.then(response => JSON.parse(response.data));
	},
	saveStockCountSchedule({ outlet_id, params } = {}) {
		return serverAddr.post(
			`/outlet/${outlet_id}/stock-count/calendar/save/`,
			params
		);
	},
	getStoreData({ get_all = true } = {}) {
		return serverAddr.get(`outlet/?get_all=${get_all}`);
	},

	//stock count apis
	getStockCount({ outletId, date, pageInfo } = {}) {
		console.log("pageInfo", pageInfo);
		// return serverAddr.get(
		// 	`/outlet/${outletId}/inventory/stock-count/${date}/?page=${
		// 		pageInfo.currentPage
		// 	}&page_size=${pageInfo.pageSize}`
		// );
		return serverAddr.get(
			`/outlet/${outletId}/inventory/stock-count/?expired=false&page=${
				pageInfo.currentPage
			}&page_size=${pageInfo.pageSize}&from_date=${date}&to_date=${date}`
		);
	},
	saveStockCount({ outletId, date, params } = {}) {
		return serverAddr.post(
			`/outlet/${outletId}/stock-count/${date}/save/`,
			params
		);
	},
	saveWastageCount({ outletId, date, params } = {}) {
		return serverAddr.post(
			`/outlet/${outletId}/stock-count/${date}/wastage/save/`,
			params
		);
	},
	getDepartmentByCategory(id, pageInfo) {
		return serverAddr.get(
			`/product/category/?department=${id}&page=${
				pageInfo.currentPage
			}&page_size=${pageInfo.pageSize}`
		);
	},
	getCategoryBySubCategory(id, pageInfo) {
		return serverAddr.get(
			`/product/subcategory/?category=${id}&page=${
				pageInfo.currentPage
			}&page_size=${pageInfo.pageSize}`
		);
	},
	getSubCategoryByItem(params, pageInfo) {
		return serverAddr.post(
			`/outlet/inventory-usage/report/?page=${pageInfo.currentPage}&page_size=${
				pageInfo.pageSize
			}`,
			params
		);
	},
	nameMapping(params) {
		return serverAddr.post(`/common/name-mapping/`, params);
	},
	getInventoryPopupTable(params, pageInfo) {
		return serverAddr.post(
			`/outlet/inventory-usage/coverage-days/?page=${
				pageInfo.currentPage
			}&page_size=${pageInfo.pageSize}`,
			params
		);
	},
	inventorySummary(params) {
		return serverAddr.post(
			`/outlet/inventory-usage/inventory-summary/`,
			params
		);
	},
	getIntermediateRecipe(params) {
		return serverAddr.get(
			`/product/${params.product_id}/?check_intermediate=true&fields=code,cost_percent,department,id,name,prep_location,preparation_instructions,price,recipe_cost,serveware,special_instructions,recipe_steps`
		);
	},
	getAllStoreData() {
		return serverAddr.get("outlet/?get_all=true");
	},
	getRecipeData(payload) {
		return serverAddr.post("/product/outlet-recipe/get-recipe-list/", payload);
	},
	getProductRecipeData(payload) {
		return serverAddr.post("/product/outlet-recipe/get-product-recipe/", payload);
	},
	getRawMaterial(payload) {
		return serverAddr.post("/product/outlet-recipe/get-raw-materials/", payload);
	},
	createUpdateProduct(payload) {
		return serverAddr.post("/product/outlet-recipe/create-update-recipe/", payload);
	},
	getNewRecipeList(payload) {
		return serverAddr.post("/product/outlet-recipe/get-new-recipe-list/", payload);
	},
	// New updated Orders page API
	getOrdersDetails(payload) {
		return serverAddr.post("/orders/ol_odr/outlet-orders/", payload);
	},
	getOrdersDetailsSummary(payload) {
		return serverAddr.post("/orders/ol_odr/outlet-orders-summary/", payload);
	},
	updateOrderQty(payload) {
		return serverAddr.post("/orders/ol_odr/update-qty/", payload);
	},
	downloadOrdersCsv(payload) {
		return serverAddrForCSV.post("/orders/ol_odr/download-order/", payload);
	},
	downloadOrdersReport(payload){
		return serverAddrForXLSX.post(`/orders/ol_odr/download-sale-order-report/`, payload);
	},
	getOrderDeptData(payload){
		return serverAddr.post(`/orders/ol_odr/get-inventory-item-departments/`, payload);
	},
	getSuppliersData(payload){
		return serverAddr.post(`/orders/ol_odr/get-inventory-item-suppliers/`, payload);
	},
};
